import React from "react";
import { CSSTransition } from "react-transition-group";
import getClassName from "../../utilities/getClassName";
import { useEffect, useRef, useState } from "react";
import Button from "../ui/Button";
import LoadingOverlay from "../shared/LoadingOverlay";
import CloseCross from "../ui/CloseCross";
import { Link } from "react-router-dom";

const CompareButtonsBar = ({
    showCompare,
    compareBarRef,
    compareButtonRef,
    showCompareBarHandler,
    numberOfOptions,
    compareSelection,
    compareOptions,
    onToggleOption,
    selectAllHandler,
    clearAllHandler,
    closeCompare,
    sharedPage,
    backLink,
}) => {
    let sending = false;
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    // Hooks
    const transitionRef = useRef(null);

    useEffect(() => {
        if (!showCompare || !compareButtonRef?.current) {
            return;
        }

        const updateDropdownPosition = () => {
            const buttonRect = compareButtonRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: buttonRect.bottom + 8,
                left: buttonRect.left,
            });
        };

        updateDropdownPosition();
        window.addEventListener("resize", updateDropdownPosition);
        window.addEventListener("scroll", updateDropdownPosition, true);

        return () => {
            window.removeEventListener("resize", updateDropdownPosition);
            window.removeEventListener("scroll", updateDropdownPosition, true);
        };
    }, [showCompare, compareButtonRef]);

    // Build compare link
    let link = `/quote/compare${backLink}`;
    if (sharedPage) {
        link = `/shared-quote/compare${backLink}`;
    }

    return (
        <CSSTransition
            nodeRef={transitionRef}
            in={showCompare}
            timeout={500}
            unmountOnExit
            classNames={{
                enterDone: "compare-buttons-bar--active",
                enterActive: "compare-buttons-bar--transition-in",
                exitActive: "compare-buttons-bar--transition-out",
            }}
        >
            <div
                ref={transitionRef}
                className={getClassName(["compare-buttons-bar"])}
                style={{ top: `${dropdownPosition.top}px`, left: `${dropdownPosition.left}px` }}
            >
                <div className="compare-buttons-bar__inner" ref={compareBarRef}>
                    {sending && <LoadingOverlay hideLoader />}

                    {compareSelection.length >= 2 ? (
                        <>
                            <div className="compare-buttons-bar__inner__title">
                                {compareSelection.length} option{compareSelection.length === 1 ? null : "s"} selected
                            </div>
                            <div className="compare-buttons-bar__inner__options">
                                {compareOptions.map((option) => (
                                    <button
                                        key={option.id}
                                        type="button"
                                        className="compare-buttons-bar__inner__option"
                                        onClick={() => onToggleOption(option.id)}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={compareSelection.includes(option.id)}
                                            readOnly
                                        />
                                        <span>{option.name}</span>
                                    </button>
                                ))}
                            </div>
                            <div className="compare-buttons-bar__inner__buttons-wrapper">
                                <Link to={link}>
                                    <Button onClick={closeCompare}>Compare</Button>
                                </Link>
                                <Button
                                    classNames={["button--white", "button--remove-background-color"]}
                                    onClick={clearAllHandler}
                                >
                                    Clear all
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="compare-buttons-bar__inner__title">
                                {compareSelection.length === 1 ? (
                                    <>Please select another option to compare</>
                                ) : (
                                    <>
                                        {numberOfOptions} option{numberOfOptions === 1 ? null : "s"} available
                                    </>
                                )}
                            </div>
                            <div className="compare-buttons-bar__inner__options">
                                {compareOptions.map((option) => (
                                    <button
                                        key={option.id}
                                        type="button"
                                        className="compare-buttons-bar__inner__option"
                                        onClick={() => onToggleOption(option.id)}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={compareSelection.includes(option.id)}
                                            readOnly
                                        />
                                        <span>{option.name}</span>
                                    </button>
                                ))}
                            </div>
                            <div className="compare-buttons-bar__inner__buttons-wrapper">
                                <Button onClick={selectAllHandler}>Select All</Button>
                                {compareSelection.length === 1 && (
                                    <Button
                                        classNames={["button--white", "button--remove-background-color"]}
                                        onClick={clearAllHandler}
                                    >
                                        Clear all
                                    </Button>
                                )}
                            </div>
                        </>
                    )}
                    <div className="compare-buttons-bar__inner__close-cross">
                        <CloseCross onClick={showCompareBarHandler} />
                    </div>
                </div>
            </div>
        </CSSTransition>
    );
};

export default CompareButtonsBar;
